import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline3 from '../Typography/Heading/Headline3';
import Body1 from '../Typography/Body/Body1';
import { Breadcrumbs } from '../Breadcrumb';
import { Grid, GridCell } from '../Grid';
import breakpoints from '../Theme/breakpoints';

const MainTitle = styled(Headline3)`
  && {
    text-align: center;
    display: block;
    padding: 0 16px 0;
    margin: 0 0 16px;

    @media (min-width: ${breakpoints.md}px) {
      padding: 0;
    }
  }
`;

const StyledBody1 = styled(Body1)`
  && {
    text-align: center;
    padding: 0 16px;

    @media (min-width: ${breakpoints.md}px) {
      padding: 0;
    }
  }
`;

const specialsPagePropertyTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  specialLinks: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
  children: PropTypes.node,
  adSlot: PropTypes.node,
};

type SpecialsPageProperties = InferProps<typeof specialsPagePropertyTypes>;

const SpecialsPage = ({
  breadcrumbs,
  title,
  description,
  specialLinks,
  children,
  adSlot,
}: SpecialsPageProperties) => (
  <Grid>
    <GridCell padding="0 16px 20px">
      <Breadcrumbs
        crumbs={breadcrumbs}
      />
    </GridCell>
    <GridCell columns={12} padding="16px">
      <MainTitle tag="h1">
        {title}
      </MainTitle>
      { adSlot && (
      <GridCell padding="16px 0 32px">
        {adSlot}
      </GridCell>
      )}
      <StyledBody1>
        {description}
      </StyledBody1>
      { specialLinks }
    </GridCell>
    {children}
  </Grid>
);

SpecialsPage.propTypes = specialsPagePropertyTypes;

SpecialsPage.defaultProps = {
  children: undefined,
  specialLinks: undefined,
  adSlot: undefined,
};

export default SpecialsPage;
